import { message } from "antd";
import axios from "axios";
import { IaxiosConfig, IresponseData } from "./types/type";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

/* ##############################
                                #
  Api сервис - V 1.1            #
                                #
############################## */

//hostDomain - домен
//hostPort - порт
//wordAfterPort - обращение к апи

//private link - путь к конроллеру
//private defaultConfig - Объект конфигурации Axios
//private auth - Для проверки аутентифицированный ли запрос(для метода public configAxios)
//private Morelinks - Массив путей контроллера(для метода public useMoreAxios)

const hostDomain = process.env.REACT_APP_API_URL;
const hostPort = "";
const wordAfterPort = "/api/";
export const hostURL = hostDomain + hostPort;
//Класс для взаимодействия с api Axios
export class API_CENTER {
  static clientAxios(arg0: string, arg1: string) {
    throw new Error("Method not implemented." + arg0 + arg1);
  }
  private link!: string;
  private defaultConfig: IaxiosConfig = {
    baseURL: hostURL + wordAfterPort,
  };
  private auth?: boolean = false;
  private allowNotifications?: boolean = true;
  private Morelinks!: string[];

  //Метод инициализации запроса аутентифицированного
  public authAxios(link: string, method?: string, data?: any) {
    // link - имя Api
    // method - POST GET ...
    // data - данные отправляемые на Бек
    this.auth = true; //флаг аутенцифицированного запроса
    this.useToken();
    link = "auth/" + link; //при аутенцифицированном запросе к link добавлям префикс auth
    return this.useAxios(link, method, data);
  }
  public clientAxios(link: string, method?: string, data?: any) {
    // link - имя Api
    // method - POST GET ...
    // data - данные отправляемые на Бек
    this.auth = true; //флаг аутенцифицированного запроса
    this.useToken();
    link = "client/" + link; //при аутенцифицированном запросе к link добавлям префикс auth
    return this.useAxios(link, method, data);
  }
  public GET_API(link: string, method?: string, data?: any) {
    // link - имя Api
    // method - POST GET ...
    // data - данные отправляемые на Бек
    this.auth = true; //флаг аутенцифицированного запроса
    this.useToken();
    NProgress.start();
    // if (localStorage.getItem("role") === "299") {
    //   link = "client/" + link;
    // } //при аутенцифицированном запросе к link добавлям префикс auth
    // if (localStorage.getItem("role") === "300") {
    //   link = "auth/" + link;
    // }
    link = "auth/" + link;
    return this.useAxios(link, method, data);
  }
  //Метод инициализации запроса
  public useAxios(link: string, method?: string, data?: any) {
    // link - имя Api
    // method - POST GET ...
    // data - данные отправляемые на Бек
    this.link = link;
    method ? (this.defaultConfig["method"] = method) : null;
    data ? (this.defaultConfig["data"] = data) : null;
    return this.goToServer();
  }

  //Метод запроса с использованием объекта конфигурации Axios
  public configAxios(
    link: string,
    config: IaxiosConfig,
    auth?: boolean,
    allowNotifications?: boolean
  ) {
    // link - имя Api
    // config - объект конфигурации AXIOS
    // auth - аутентифицированный запрос ли
    this.link = link;

    this.defaultConfig = Object.assign(this.defaultConfig, config); // добавляет ключи объекта в private defaultConfig
    if (allowNotifications === false) {
      this.allowNotifications = false;
    }
    if (auth) {
      this.auth = true;
      this.useToken();
    }
    return this.goToServer();
  }

  //Метод инициализации мультипликационного запроса
  public useMoreAxios(links: string[], config?: IaxiosConfig) {
    this.Morelinks = links;
    if (config) {
      this.defaultConfig = Object.assign(this.defaultConfig, config);
    }
    this.useToken();
    return this.goToServerMultiply();
  }

  //Запрос на сервер
  private goToServer() {
    NProgress.start();

    return axios(this.link, this.defaultConfig)
      .then((res) => {
        // res.data - путь к ответу бека в объекте Axios
        // условие, если бек ответил
        if (res.data) {
          // если есть ключ message в ответе бека, то выводим это сообщение
          // если нет то код status для вывода сообщения по регламентируемым значениям
          if (this.allowNotifications) {
            res.data.message
              ? this.apiNotification(555, res.data.message)
              : this.apiNotification(res.status);
          }
          // если в ответе бека есть ключ token то от перезаписывает токен localStorage
          // и возвращает ключ data
          NProgress.done();

          return res.data.token ? this.storeToken(res.data) : res.data;
        } else {
          NProgress.done();
          this.apiNotification(res.status);
          return undefined;
        }
      })
      .catch((err) => {
        // при возникновении ошибки 401, если был аутенцифицированный запрос
        // пытается обновить токен и провести неудавшийся запрос
        if (this.auth && err.response.status === 401) {
          return this.refresh();
        }
        // Если в ответе сервера есть ошибка то выводит ее в сообщении
        err.response.data.message
          ? this.apiNotification(666, err.response.data.message)
          : this.apiNotification(err.response.status);
        //  возвращает на фронт данные, если присутствует ключ data
        return err.response.data ? err.response.data : undefined;
      });
  }

  //Обработка Axios'ом нескольких запросов
  private mapAxios() {
    return this.Morelinks.map((i) => {
      // делает запросы по массиву путей к api с соответстующей defaultConfig
      return axios(i, this.defaultConfig);
    });
  }

  //Отправка нескольких запросов
  private goToServerMultiply() {
    return Promise.all(this.mapAxios())
      .then((res) => {
        this.apiNotification(res[1].status);
        //  возвращает все ключи data в промис
        return res.map((i) => {
          return i.data;
        });
      })
      .catch((err) => {
        return err.response.status === 401
          ? this.refresh(true)
          : this.apiNotification(err.response.status);
      });
  }

  // Рефреш токена
  private refresh(multyply?: boolean): Promise<any> {
    // multyply - мультипликационный запрос ли( useMoreAxios )

    // dataToRefresh- данные для отправки токена для рефреша
    const dataToRefresh: { refresh_token: string; role?: number } = {
      refresh_token: localStorage.refresh_token,
    };

    // рефреш для агента
    // if (localStorage.role == 300) {
    //   dataToRefresh["role"] = 300;
    // }
    return axios
      .post("refreshToken", dataToRefresh, {
        baseURL: hostURL + wordAfterPort,
      })
      .then((res) => {
        localStorage.setItem("access_token", res.data.data.access_token);
        // localStorage.setItem("refresh_token", res.data.data.refresh_token);
        this.useToken();
        return multyply ? this.goToServerMultiply() : this.goToServer();
      })
      .catch(() => {
        // если токен не смог обносится очищает localStorage
        localStorage.clear();
        window.location.replace("/login");
      });
  }

  /* Работает не всегда правильно с  configAxios и useMoreAxios */
  //Добавляет или меняет токен для аутентифицированного запроса в header
  private useToken() {
    // this.defaultConfig.headers.Authorization =
    //   "Bearer " + localStorage.access_token;
    this.defaultConfig["headers"] = {
      Authorization: "Bearer " + localStorage.access_token,
    };
  }

  //Добавляет токен в локальное хранилище
  private storeToken(data: IresponseData) {
    // data - данные бэка
    localStorage.access_token = data.token;
    // localStorage.setItem("auth", JSON.stringify(data));
    // localStorage.refresh_token = data.refresh_token;
    data.role ? (localStorage.role = data.role) : null;
    return data;
  }

  //Для отображения уведомлений
  private apiNotification(status: number, messageServer?: string) {
    // status - статус ответа
    // messageServer - сообщение от бека
    // time - время показа уведомления
    NProgress.done();
    const time = 3;
    switch (status) {
      case 200:
        message.success({ content: "Выполнено", duration: time });
        break;
      case 201:
        message.success({ content: "Действие выполнено", duration: time });
        break;
      case 202:
        message.success({ content: "Роль изменена", duration: time });
        break;
      case 401:
        message.error({ content: "Авторизация не прошла", duration: time });
        break;
      case 403:
        message.error({
          content: "Email существует в системе",
          duration: time,
        });
        break;
      case 404:
        message.error({ content: "Запрос не найден", duration: time });
        break;
      case 422:
        message.error({
          content: "Пользователь существует в системе",
          duration: time,
        });
        break;
      case 500:
        message.error({ content: "Проблемы с сервером", duration: time });
        break;
      case 555:
        message.success({ content: messageServer, duration: time });
        break;
      case 666:
        message.error({ content: messageServer, duration: time });
        break;
      default:
        message.error({ content: "Что-то пошло не так", duration: time });
        break;
    }
  }
}
